module.exports = __webpack_public_path__ + "static/contact-eff9f05c435ccff8016a48977968eef6.png";